module.exports = __webpack_public_path__ + "static/media/ACTOS.ebf6bcf7.jpg";